import { useState } from 'react';
import { useDivisionLogos } from '../../lib/division-logo';

/** The Division cell: the division's icon on a small round plate when it has
    one (a logo that fails to load is dropped), then its name. Sized to sit in
    the row's text line, so the row keeps its height. The logo is looked up
    here, so tables without the column never read the user or accounts. */
export function DivisionLabel({
  label,
  division,
}: {
  label: string;
  division: { id?: string | null; name?: string | null };
}) {
  const logoUrl = useDivisionLogos()(division);
  const [broken, setBroken] = useState(false);
  const icon = logoUrl && !broken;

  return (
    <span className="sk:inline-flex sk:min-w-0 sk:items-center sk:gap-2">
      {icon && (
        <span className="sk:bg-surface sk:inset-shadow-hairline sk:flex sk:size-5 sk:shrink-0 sk:items-center sk:justify-center sk:overflow-hidden sk:rounded-full">
          <img
            src={logoUrl}
            alt=""
            className="sk:size-4 sk:object-contain"
            onError={() => setBroken(true)}
          />
        </span>
      )}
      <span className="sk:truncate">{label}</span>
    </span>
  );
}
